import { render, staticRenderFns } from "./DashboardStatues.vue?vue&type=template&id=25af3cb8"
import script from "./DashboardStatues.vue?vue&type=script&lang=js"
export * from "./DashboardStatues.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatues.vue?vue&type=style&index=0&id=25af3cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports